<div class="zk-flex zk-flex-row zk-items-center zk-justify-between zk-p-4 zk-pl-6 insights-tiers-sugestions">
	<div class="zk-flex zk-flex-col">
		<p id="insights-greetings" freud-typography fontType="bodyRegularAuto">
			{{ 'INSIGHTS.SUGESTIONS.TIERS.GREETINGS' | translate: { displayName } }}
		</p>
		<p id="insights-increase-elegibles" freud-typography fontType="bodyRegularAuto">
			{{	'INSIGHTS.SUGESTIONS.TIERS.INCREASE_ELEGIBLES' | translate: { totalEligibles: totalEligibles.toLocaleString('pt-BR') } }}
		</p>
	</div>
	<freud-button class="insights-tiers-button" (click)="redirectToAccountSettings()">
		{{ 'INSIGHTS.SUGESTIONS.TIERS.BUTTON' | translate }}
	</freud-button>
</div>	

